// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"502":"2535ecd2","842":"a6e8c75d"}[chunkId] + ".chunk.js";
};